var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkCompleteModalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 104,
    viewBox: "0 0 216 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 91H137C137.515 91 138.017 90.9444 138.5 90.8389C138.983 90.9444 139.485 91 140 91H192C195.866 91 199 87.866 199 84C199 80.134 195.866 77 192 77H186C182.134 77 179 73.866 179 70C179 66.134 182.134 63 186 63H205C208.866 63 212 59.866 212 56C212 52.134 208.866 49 205 49H183C186.866 49 190 45.866 190 42C190 38.134 186.866 35 183 35H119C122.866 35 126 31.866 126 28C126 24.134 122.866 21 119 21H62C58.134 21 55 24.134 55 28C55 31.866 58.134 35 62 35H22C18.134 35 15 38.134 15 42C15 45.866 18.134 49 22 49H47C50.866 49 54 52.134 54 56C54 59.866 50.866 63 47 63H7C3.13401 63 0 66.134 0 70C0 73.866 3.13401 77 7 77H46C42.134 77 39 80.134 39 84C39 87.866 42.134 91 46 91ZM209 91C212.866 91 216 87.866 216 84C216 80.134 212.866 77 209 77C205.134 77 202 80.134 202 84C202 87.866 205.134 91 209 91Z",
    fill: "#F4F9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141 7C142.657 7 144 5.65685 144 4C144 2.34315 142.657 1 141 1C139.343 1 138 2.34315 138 4C138 5.65685 139.343 7 141 7Z",
    fill: "#044D6E",
    stroke: "#044D6E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172 23C173.657 23 175 21.6569 175 20C175 18.3431 173.657 17 172 17C170.343 17 169 18.3431 169 20C169 21.6569 170.343 23 172 23Z",
    fill: "#044D6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.243 14.7573L148.885 23.1156L157.243 14.7573ZM148.758 14.7573L157.116 23.1156L148.758 14.7573Z",
    fill: "#044D6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.758 14.7573L157.116 23.1156M157.243 14.7573L148.885 23.1156L157.243 14.7573Z",
    stroke: "#044D6E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4043 32.5962L54.4043 38.5962L60.4043 32.5962ZM54.4043 32.5962L60.4043 38.5962L54.4043 32.5962Z",
    fill: "#044D6E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4043 32.5962L60.4043 38.5962M60.4043 32.5962L54.4043 38.5962L60.4043 32.5962Z",
    stroke: "#044D6E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68 26C69.6569 26 71 24.6569 71 23C71 21.3431 69.6569 20 68 20C66.3431 20 65 21.3431 65 23C65 24.6569 66.3431 26 68 26Z",
    fill: "#044D6E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.04 97.0048L84.1711 89.2358C87.7049 76.4764 97.0114 70.0293 106.318 70.0293",
    stroke: "#044D6E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.318 69.9755C113.767 69.9755 119.806 63.9368 119.806 56.4877C119.806 49.0387 113.767 43 106.318 43C98.8687 43 92.8301 49.0387 92.8301 56.4877C92.8301 63.9368 98.8687 69.9755 106.318 69.9755Z",
    stroke: "#044D6E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.488 101.975C126.937 101.975 132.975 95.9368 132.975 88.4877C132.975 81.0387 126.937 75 119.488 75C112.039 75 106 81.0387 106 88.4877C106 95.9368 112.039 101.975 119.488 101.975Z",
    stroke: "#044D6E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.488 88.4877L117.988 91.9877L124.488 85.4877",
    stroke: "#044D6E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkCompleteModalImage);
export default __webpack_public_path__ + "static/media/mark-complete-modal-image.496d5c43b559cf0a9b010b5215ba17e9.svg";
export { ForwardRef as ReactComponent };